//  Link media
require.context('../media/', true, /^\.\/.*\.*/);
require.context('../fonts/', true, /^\.\/.*\.*/);

//  Styles
import '../styles/styles.scss';

// JS
import $ from 'jquery';

import utils from './proj/utils';
import handleLazySizes from './proj/handleLazySizes';
import handleContainSizing from './proj/handleContainSizing';
// import Slick from './proj/slick';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger); 


let Site;
const isMobileDevice = utils.mobileAndTabletCheck();
const isMobile = window.innerWidth < 800 || isMobileDevice;


(function ($) {
	'use strict';

	Site = {
		/**
		 * initialize prototype
		 *
		 */
		init: function (elt) {
			var self = this;

			
			// ONLY FOR LOCALHOST until script fixed
			if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
				var barEl = document.getElementById('cnn-header');
				if(barEl) {
					self.navshare();
				}
			}

			// self.scrollToAnchor();
			self.newWindowLink();
			self.toggleVideo();
			self.handleVideoSrc();
			self.playVideoIntro();
			self.imagePlx();
			self.firstLoadAnimation();
			self.toggleMenu();
			self.countUpNumbers();
		},

		toggleVideo: function(){

			const self = this;

			var iframe = $('iframe:visible');
			var player = new Vimeo.Player(iframe.get(0));

			let vidIsPlaying = false; 

			player.on('play', function() {
		     	vidIsPlaying = true;
		    });
		    player.on('pause', function() {
		     	vidIsPlaying = false;
		    });

			// self.loadVideoTracking(iframe);

			$('.video .js-poster, .play').on('click', function(e){
				e.preventDefault();
				e.stopPropagation();
				$('.video').toggleClass('is-open');

				if($('.video').hasClass('is-open')) {
					player.play();
				}
				else {
					player.pause()
				}
			});

			// player
			// ScrollTrigger.create({
			// 	trigger: '.video',
			// 	scrub: true,
			// 	// markers: true,
			// 	start: "top top",
			// 	end: "+="+($('.video').height() - 120),
			// 	onLeave: function(){
			// 		if($('.video').hasClass('is-open')) {
			// 			// player.pause()
			// 		}
			// 	},
			// 	onEnterBack: function(){
			// 		if($('.video').hasClass('is-open')) {
			// 			// player.play()
			// 		}
			// 	},
			// });

			// ScrollTrigger.create({
			// 	trigger: "#hero", 
			// 	// markers: true,
			// 	pin: false,
			// 	start: "-65",
			// 	end: "bottom top",
			// 	onEnterBack: function(){
			// 		if($('.video').hasClass('is-open')) {
			// 			// if(vidIsPlaying) {
			// 				$('.sticky-container').removeClass('is-sticky');
			// 			// }
			// 		}
			// 	},
			// 	onEnter: function(){
			// 		if($('.video').hasClass('is-open')) {
			// 			// if(vidIsPlaying) {
			// 				$('.sticky-container').removeClass('is-sticky');
			// 			// }
			// 		}
			// 	},
			// 	onLeave: function(){
			// 		if($('.video').hasClass('is-open')) {
			// 			if(vidIsPlaying) {
			// 				$('.sticky-container').addClass('is-sticky');
			// 			}
			// 		}
			// 	},
			// 	onLeaveBack: function(){
			// 		if($('.video').hasClass('is-open')) {
			// 			if(vidIsPlaying) {
			// 				$('.sticky-container').addClass('is-sticky');
			// 			}
			// 		}
			// 	}
			// });

			// $('.sticky-container__close').on('click', function() {
			// 	$('.sticky-container').removeClass('is-sticky');
			// 	player.pause();
			// });

		},

		toggleMenu: function(){
			
			$('.toggleMenu').on('click', function(){
				// $('.toggleMenu').toggleClass('is-active');
				// if($('.js-main-menu-toggle').hasClass('is-active')) {
				// 	$(this).attr('aria-expanded', true);
				// }
				// else {
				// 	$('body').removeClass('noscroll menu-open');
				// 	$(this).attr('aria-expanded', false);
				// }
				$('body').toggleClass('noscroll menu-open');
			});
			// $('.aside-more-series a').on('click', function(){
			// 	$('.js-main-menu-toggle').removeClass('is-active');
			// 	$('body').removeClass('noscroll menu-open');
			// });

			// press excap key to close menu too
			$(document).keyup(function(e) {
				if (e.key === "Escape") { // escape key maps to keycode `27`
					if($('body').hasClass('menu-open')) {
						$('.toggleMenu').eq(0).trigger('click');
					}
				}
			});

		},
		firstLoadAnimation: function(){
	
			// HERO
			gsap.timeline({ease: "linear"})
				.to('#app', { autoAlpha:1 })
				.from('.hero-clientlogo', { opacity: '0', scale: 1, y: '10px', duration: 1 })
				.from('h1', { opacity: '0', scale: 1, y: '10px', duration: 1 })
				.call(function(argument) {
					$('h1').addClass('is-underlined');
					$('.hero .video__media').addClass('fadein');
				})
				.from('.afterhero p, .afterhero h2', { opacity: '0', scale: 1, y: '10px', duration: 1 }, "+=0.8")



			$('.mod-title, .mod-blockquote').each(function(index, section){
				let tl = gsap.timeline()
     						.from($(this), { opacity: '0', duration: 1 })
     						.call(function(argument) {
     							$(this).addClass('is-underlined');
     						})

				ScrollTrigger.create({
					trigger: section,
					scrub: true,
					start: "top 85%",
					onEnter: function(){
						$(section).addClass('is-underlined');
					}
				});
			});
			
			$('.graphic--1').each(function(index, section){

				// gsap.set($(section).find('.base img'), {opacity: 0});
				gsap.set($(section).find('.c1'), {opacity: 0});
				gsap.set($(section).find('.c2'), {opacity: 0});
				gsap.set($(section).find('.c3'), {opacity: 0});

				let tl = gsap.timeline()
									.from($(section).find('.base img'), { opacity: 0, rotation: -145,  duration: 1 })
									.to($(section).find('.c3'), { opacity: 1, rotation: 120,  duration: 1 }, '-=0.9')
									.to($(section).find('.c2'), { opacity: 1, rotation: 40, duration: 1 }, '-=0.9')
									.to($(section).find('.c1'), { opacity: 1, rotation: 80, duration: 1 }, '-=0.9');

				ScrollTrigger.create({
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					animation: tl,
				});
			})
			$('.graphic--2').each(function(index, section){

				gsap.set($(section).find('.cog'), {opacity: 0});
				// .to($(section).find('.g2-africa'), { opacity: 1, duration: 1 })
				let tl = gsap.timeline().to($(section).find('.cog'), { opacity: 1, rotation: 40, duration: 1 }, '<');

				ScrollTrigger.create({
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					animation: tl,
				});
			})


			$('.a2graphic--1').each(function(index, section){

				// gsap.set($(section).find('.base img'), {opacity: 0});
				// gsap.set($(section).find('.c1'), {opacity: 0});
				// gsap.set($(section).find('.c2'), {opacity: 0});
				// gsap.set($(section).find('.c3'), {opacity: 0});

				let tl = gsap.timeline()
									.from($(section).find('.base img'), { opacity: 0, duration: 1 })

				ScrollTrigger.create({
					trigger: section,
					start: "top bottom",
					end: "bottom 50%",
					scrub: true,
					animation: tl,
				});
			})

			$('.a2graphic--2').each(function(index, section){

				let tl = gsap.timeline()
						.from($(section), { opacity: 0, duration: 1 })

				ScrollTrigger.create({
					trigger: section,
					start: "top bottom",
					end: "bottom 50%",
					scrub: true,
					animation: tl,
				});
			});


			$('.a3graphic--1').each(function(index, section){

				gsap.set($(section).find('.base img'), {opacity: 0});
				gsap.set($(section).find('.c1'), {opacity: 0});
				gsap.set($(section).find('.c2'), {opacity: 0});

				let tl = gsap.timeline()
									.to($(section).find('.base img'), { opacity: 1, duration: 1 })
									.to($(section).find('.c2'), { opacity: 1, rotation: 40, duration: 1 }, '-=0.9')
									.to($(section).find('.c1'), { opacity: 1, rotation: 80, duration: 1 }, '-=0.9');

				ScrollTrigger.create({
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					animation: tl,
				});
			})

			$('.a3graphic--2').each(function(index, section){

				gsap.set($(section).find('.face1'), {opacity: 0});
				gsap.set($(section).find('.face2'), {opacity: 0});
				// .to($(section).find('.g2-africa'), { opacity: 1, duration: 1 })
				let tl = gsap.timeline()
						.to($(section).find('.face1'), { opacity: 1, duration: 1 }, '<')
						.to($(section).find('.face2'), { opacity: 1, y: 40, duration: 1 }, '<');

				ScrollTrigger.create({
					trigger: section,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					animation: tl,
				});
			})


			$('.a4graphic--1').each(function(index, section){

				let tl = gsap.timeline()
					.from($(section).find('.base img'), { opacity: 0, scale: 0.9, duration: 1 })

				ScrollTrigger.create({
					trigger: section,
					start: "top bottom",
					end: "bottom 50%",
					scrub: true,
					animation: tl,
				});
			});


			$('.eventinfo .line1-left, .eventinfo .line2-left').each(function(index, section){
				var elts = $(this).find('.event-tag');
					gsap.set(elts, {opacity: 0, y:0, x:-40});
			});
			$('.eventinfo .line1-right, .eventinfo .line2-right').each(function(index, section){
				var elts = $(this).find('.event-tag');
					gsap.set(elts, {opacity: 0, y:0, x:40});
			});
			$('.eventinfo .line3').each(function(index, section){
				var elts = $(this).find('.event-tag');
					gsap.set(elts, {opacity: 0, y:20, x:0});
			});
			$('.eventinfo').each(function(index, section){
				var elts = $(this);


				ScrollTrigger.create({
					trigger: elts,
					// markers: true,
					start: "top 85%",
					onEnter: function(){  
						gsap.timeline().to('.event-tag.anim0', {opacity: 1, y:0, x:0,  duration: 0.6})
										.to('.event-tag.anim1', {opacity: 0.6, y:0, x:0,  duration: 0.6}, '<')
										.to('.event-tag.anim2', {opacity: 0.6, y:0, x:0,  duration: 0.6}, "-=55%") 
										.to('.event-tag.anim3', {opacity: 0.6, y:0, x:0,  duration: 0.6}, "-=55%") 
										.to('.event-tag.anim4', {opacity: 0.6, y:0, x:0,  duration: 0.6}, "-=55%") 
					}
					,

				});
			});

			$('.shape').each(function(el){
				if(navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')){
					// it's safari	
				}
				else {
					const $el = $(this).wrap( "<div class='shape-wrapper'></div>" );
				}
			});

			function IsSafari() {

			  	var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1;
			  	return is_safari;

			}

			$('.shape-wrapper').each(function(el){
				const $el = $(this);

				ScrollTrigger.create({
					trigger: $el, 
					// markers: true,
					// id: "inview",
					start: "top bottom",
					// end: "bottom top",
					onEnter: function(){
						if (!$el.hasClass('is-inview')) {
							$el.addClass('is-inview');
						}
					},
					onLeave: function(){
						if ($el.hasClass('is-inview')) {
							$el.removeClass('is-inview');
						}
					},
					onEnterBack: function(){
						if (!$el.hasClass('is-inview')) {
							$el.addClass('is-inview');
						}
					},
					onLeaveBack: function(){
						if ($el.hasClass('is-inview')) {
							$el.removeClass('is-inview');
						}
					}
				});
				
			});

			// $('.mod-image').each(function(index, section){
			// 	var elt = $(this);
			// 	gsap.set(elt, {y: '15%' });

			// 	ScrollTrigger.create({
			// 		trigger: section,
			// 		start: "top 100%",
			// 		once: true,
			// 		onEnter: function(){
			// 			gsap.to(elt, { y: '0', duration: 0.8 })
			// 		}
			// 	});
			// })

			$('.ivanim-slidefade').each(function(){
				var elts = $(this);

				gsap.set(elts, {y: 30, opacity: 0});

				ScrollTrigger.create({
					trigger: elts,
					// markers: true,
					start: "top 95%",
					onEnter: function(){  gsap.to(elts, {opacity: 1, y: 0, duration: 0.6}) },
				});
			});
			$('.ivanim-fade').each(function(i){
				var elts = $(this);

				gsap.set(elts, {opacity: 0});

				ScrollTrigger.create({
					trigger: elts,
					// markers: true,
					start: "top 95%",
					onEnter: function(){  gsap.to(elts, {opacity: 1, duration: 0.7}) },
				});
			})  


			// END CTA
			gsap.set('.end-cta-clientlogo, .end-cta-title__title, .end-cta-title__ctas', {'opacity': 0});
			gsap.set('.end-cta-media img', { scale: '1.1' });

			var tlEndCTA = gsap.timeline({paused: true, ease: "linear"})
					.to('.end-cta-media img', { scale: '1', duration: 1 })
					.to('.end-cta-clientlogo', { opacity: '1', duration: 1 }, '<')
					.to('.end-cta-title__title', { opacity: '1', duration: 1 }, '-=0.5')
					.call(function(argument) {
						$('.end-cta-title__title').addClass('is-underlined');
					})
					.to('.end-cta-title__ctas', { opacity: '1', duration: 1 }, '-=0.5')

			ScrollTrigger.create({
				trigger: ".end-cta", 
				// markers: true,
				pin: false,
				start: "top 90%",
				once: true,
				onEnter: function(){
					tlEndCTA.restart();
				}
			});

			// ScrollTrigger.saveStyles('.image-text__media, .image-fullwidth__media, .video__media');

			window.addEventListener("resize", utils.debounce(function(e){
				ScrollTrigger.refresh(true);
			}));

		},

		countUpNumbers: function (section) {
			function numberWithCommas(x) {
				return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			}
		
			function animateState(el){
				const count = $(el);
				const comma = $(el).data('comma') || true;
				const countUpDuration = $(el).attr('data-duration') || 1;
		
				gsap.to(count, {
					innerText: count.attr("data-number"),
					snap: {innerText: 1},
					stagger: {
						each: 1.0,
						onUpdate: function() {
							if(comma) {
								this.targets()[0].innerHTML = numberWithCommas(Math.ceil(this.targets()[0].innerText));
							}
						},
					},
					duration: countUpDuration
				});
		
			}
	
			$('.js-stat-number').each(function(el){

				const $el = $(this);

				ScrollTrigger.create({
					trigger: $el, 
					// markers: true,
					id: "inview",
					start: "top 95%",
					onEnter: function(){
						$('.js-stat-number').html(0);
						animateState($el);
						// if (!$el.hasClass('is-inview')) {
							// $el.addClass('is-inview');
						// }
					},
					onEnterBack: function(){
						$('.js-stat-number').html(0);
						animateState($el);
					}
				});
				
			});
		
		},

		imagePlx: function(){

			$('.figure-container-plx').each(function(index){
				var elt = $(this);

				var w = elt.find('svg').attr('width');
				var h = elt.find('svg').attr('height') - elt.find('svg').attr('height')*0.15;

				// use svg to set image size
				elt.find('svg').attr('width', w);
				elt.find('svg').attr('height', h);
				elt.find('svg').removeAttr('viewBox');
				elt.find('svg').attr('viewBox', "0 0 "+w+" "+h);
			});


			$('.figure-container-plx').find('img').each(function(){
				// $(this).on('load', function(){
				// 	var w = $(this).width();
				// 	var h = $(this).height() - $(this).height()*0.15;

				// 	// use svg to set image size
				// 	$(this).parents('.figure-container-plx').find('svg').attr('width', w);
				// 	$(this).parents('.figure-container-plx').find('svg').attr('height', h);
				// 	$(this).parents('.figure-container-plx').find('svg').attr('viewBox', "0 0 "+w+" "+h);
				// 	// $(this).addClass('plx');

				// }).bind('error',function(ev){
				// 	// console.log('===  main.js [794] ===', ev);
				// });
				ScrollTrigger.create({
					trigger: $(this),
					scrub: true,
					// markers: true,
					start: "top bottom",
					end: "bottom top",
					animation: gsap.to($(this), { y: '-15%' })
				});

			});
		},

		/**
		 * video replace
		 *
		 */
		handleVideoSrc: function() {

			const updateVideoSrc = function(vid) {
				const src = vid.getAttribute('data-vid-src');
				const newSrc = (isMobile) ? src.replace(".mp4", "-mob.mp4") : src;
				const hasPoster = vid.getAttribute('data-hasposter');
				if (hasPoster) {
					vid.setAttribute('poster', (isMobile) ? hasPoster + '-mob.jpg' : hasPoster + '.jpg');
				}
				vid.setAttribute('src', newSrc);
			};

			const vids = document.querySelectorAll("video[data-vid-src]");
			[...vids].forEach( updateVideoSrc );

			
		},
		playVideoIntro: function(){

			const playVideo = function(vid) {

				var playPromise = vid.play();

				if (playPromise !== undefined) {
					playPromise.then(function() {
						// Automatic playback started!
					}).catch(function(error) {
						vid.muted = true;
						vid.play();
						// Automatic playback failed.
						// Show a UI element to let the user manually start playback.
					});
				}
			};
			const pauseVideo = function(vid) {
				vid.pause();
			};

			//reset video to start
			var v = document.getElementById('intro_video');
			var v_mob; 
			if(document.getElementById('intro_video_mob')){
				v_mob = document.getElementById('intro_video_mob');
			}


			playVideo(v);
			if(v_mob != undefined) {
				playVideo(v_mob);
			}
			// console.log('===  main.js [185] ===', v);
			
			ScrollTrigger.create({
				trigger: '.hero',
				onLeave: function(){
					pauseVideo(v);
					if(v_mob != undefined) {
						pauseVideo(v_mob);
					}
				},
				onEnter: function(){
					// playVideo(v);
				},
				onEnterBack: function(){
					playVideo(v);
					if(v_mob != undefined) {
						playVideo(v_mob);
					}
				},
				onLeaveBack: function(){
					// pauseVideo(v);
				},
				// markers: true,
				// id: 'hero-cte',
				start: "top -60px",
				// end: "bottom 50%",
			});


		},


		navshare: function(){
			const self = this;
			// Setup social share menu
			var barEl = document.getElementById('cnn-header');
			var shareEl = barEl.querySelector('[data-share]');
			var shareToggleEl = barEl.querySelector('[data-share-toggle]');

			if(shareToggleEl) {
				shareToggleEl.addEventListener('click', function(){
					if(shareEl.classList.contains('cnn-header__share--active')){
						shareEl.classList.remove('cnn-header__share--active');
					} else {
						shareEl.classList.add('cnn-header__share--active');
					}
				}, false);
			}

			// Set up scroll handler
			document.addEventListener('scroll', function() {
				window.requestAnimationFrame(self.onScroll);
			}, {passive: true});

		},
		onScroll: function(){
			// Get current scroll position
			var sPos = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY;

			var barEl = document.getElementById('cnn-header');
			if(sPos < 30) {
				if($('.cnn-header__row--gold').hasClass('cnn-header__row--sticky')) {
					$('.cnn-header__row--gold').removeClass('cnn-header__row--sticky');
				}
			} else {
				// if(!barEl.classList.contains('cnn-header--fixed')) {
				// 	barEl.classList.add('cnn-header--fixed');
				// }
				if(!$('.cnn-header__row--gold').hasClass('cnn-header__row--sticky')) {
					$('.cnn-header__row--gold').addClass('cnn-header__row--sticky');
				}
			}
		},


		/**
		 * Scroll to
		 *
		 */
		scrollToAnchor: function () {
			$('body').on('click', '.scrollTo', function(event){
				event.preventDefault();
				event.stopPropagation();

				var tag = $(this).attr('href');

				$('html,body').animate({scrollTop: $(tag).offset().top },'slow');
			});
		},

		/**
		 * Open links in new window
		 *
		 */
		newWindowLink: function () {
			$('p a[href]').not('.goto').each(function() {

				// if(!$(this).attr('href').indexOf('cnn') != -1) {
					$(this).attr('target','_blank');
				// }
			});
		},		

		/**
		 * CNN video view trackers
		 *
		 */
		loadVideoTracking: function($iFrame){
			var player = new Vimeo.Player($iFrame);
			var playedVideoTrackingFlag = true;
			var startPlayedVideoTrackingFlag = true;

			player.getVideoTitle().then(function(title) {
				// console.log('title:', title);
		
				function playedVideoTracking(title) {
					s.events = 'event32';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					s.tl(true, 'o', 'cnnadfeaturevideo:play');
					s.events = s.prop29 = s.eVar41 = '';
				}
			
				function startPlayedVideoTracking(title) {
					s.events = 'event32';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone');
					s.events = s.prop29 = s.eVar41 = '';
				}
			
				function tenPlayedVideoTracking(title) {
					s.events = 'event40,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 10% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function twentyFivePlayedVideoTracking(title) {
					s.events = 'event41,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 25% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function fiftyPlayedVideoTracking(title) {
					s.events = 'event2,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 50% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function seventyFivePlayedVideoTracking(title) {
					s.events = 'event42,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 75% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}

				function nintyPlayedVideoTracking(title) {
					s.events = 'event59,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:milestone - video 90% complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				function endVideoTracking(title) {
					s.events = 'event33,event36';
					s.prop29 = title;
					s.eVar41 = 'D=c29';
					// s.products = ';;;;event36=' + data.seconds;
					s.tl(true, 'o', 'cnnadfeaturevideo:complete');
					s.events = s.prop29 = s.eVar41 = s.products = '';
				}
			
				player.on('play', function() {
					playedVideoTracking(title);
					// playedVideoTrackingFlag = false;
					// console.log('Played the video');
				});
			
			
				var loopCount = 0;
				var tenPlayedVideoTrackingFlag = false;
				var twentyFivePlayedVideoTrackingFlag = false;
				var fiftyPlayedVideoTrackingFlag = false;
				var seventyFivePlayedVideoTrackingFlag = false;
				var nintyPlayedVideoTrackingFlag = false;
				var endVideoTrackingFlag = false;
			
				player.on('timeupdate', function(data) {
					var iNum = data.percent;
					
					if (iNum >= 0.101 && loopCount == 0 && !tenPlayedVideoTrackingFlag) {
						// console.log("Played 10%");
						tenPlayedVideoTrackingFlag = true;
						tenPlayedVideoTracking(title);
					}
					if (iNum >= 0.25 && loopCount == 0 && !twentyFivePlayedVideoTrackingFlag) {
						// console.log("Played 25%");
						twentyFivePlayedVideoTrackingFlag = true;
						twentyFivePlayedVideoTracking(title);
					}
					if (iNum >= 0.50 && loopCount == 0 && !fiftyPlayedVideoTrackingFlag) {
						// console.log("Played 50%");
						fiftyPlayedVideoTrackingFlag = true;
						fiftyPlayedVideoTracking(title);
					}
					if (iNum >= 0.75 && loopCount == 0 && !seventyFivePlayedVideoTrackingFlag ) {
						// console.log("Played 75%");
						seventyFivePlayedVideoTrackingFlag = true;
						seventyFivePlayedVideoTracking(title);
					}
					if (iNum >= 0.90 && loopCount == 0 && !nintyPlayedVideoTrackingFlag ) {
						// console.log("Played 90%");
						nintyPlayedVideoTrackingFlag = true;
						nintyPlayedVideoTracking(title);
					}
					if (iNum >= 0.99 && loopCount == 0 && !endVideoTrackingFlag) {
						// console.log("Completed");
						endVideoTrackingFlag = true;
						endVideoTracking(title);
						loopCount += 1;
					}
				});
			});
		},
	};

	$(document).ready( function(){
		Site.init();
	})

})(jQuery);



// WEBPACK FOOTER //
// ./src/js/main.js